import React from 'react';

const SideArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={6}
    height={11}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.365 9.521V1.48a.625.625 0 0 1 1.067-.442l4.02 4.02a.625.625 0 0 1 0 .884l-4.02 4.021a.625.625 0 0 1-1.067-.442Z"
    />
  </svg>
);
export default SideArrowRight;
